/**
 * @file Couleurs de skins de munitions : cache hex -> Color (aucun parsing ni allocation par frame) et teinte arc-en-ciel.
 */
import { Color } from 'three';

const cache = new Map<string, Color>();

/** Color partagee (NE PAS MODIFIER) d'une chaine hex ; parsee une seule fois. */
export const colorOf = (hex: string): Color => {
  let c = cache.get(hex);
  if (!c) {
    c = new Color(hex);
    cache.set(hex, c);
  }
  return c;
};

/** Ecrit dans `out` une teinte pastel arc-en-ciel (h en tours, 0..1). */
export const rainbowInto = (out: Color, h: number, lightness = 0.68): Color => out.setHSL(h - Math.floor(h), 0.85, lightness);
